import { render, staticRenderFns } from "./MensagemIcmsInterno.vue?vue&type=template&id=1b46ddfc&scoped=true&"
import script from "./MensagemIcmsInterno.vue?vue&type=script&lang=js&"
export * from "./MensagemIcmsInterno.vue?vue&type=script&lang=js&"
import style0 from "./MensagemIcmsInterno.vue?vue&type=style&index=0&id=1b46ddfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46ddfc",
  null
  
)

export default component.exports